/* Version: 3.5.137 */
'use client';
import React from 'react';

var LangContext = /*#__PURE__*/React.createContext();

export { LangContext as default };
